import IndeterminateProgress from "@components/Progress.Indeterminate.vue";
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    IndeterminateProgress,
    ValidationProvider
  },
  props: {
    vid: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    note: {
      type: String,
      default: undefined
    },
    value: {
      type: null,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useEmpty: {
      type: Boolean,
      default: true
    },
    emptyLabel: {
      type: String,
      default: "--"
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: function () {
    return {
      innerValue: ""
    };
  },
  created: function () {
    if (this.value) {
      this.innerValue = this.value;
    } else if (this.useEmpty) {
      this.innerValue = "";
    } else if (this.options.length > 0) {
      this.innerValue = this.options[0].value;
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue;
    },
    isPending() {
      return this.$refs.provider ? this.$refs.provider.flags.pending : false;
    }
  },
  watch: {
    innerValue(value) {
      this.$emit("input", value);
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val;
      }
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    }
  }
};